interface IsRewardAvailableParams {
  requiredPoints: number | undefined;
  pointsBalance: number | undefined;
}

export const isRewardAvailable = ({ requiredPoints = 0, pointsBalance = 0 }: IsRewardAvailableParams) => {
  return pointsBalance >= requiredPoints;
};
